// extracted by mini-css-extract-plugin
export default {"wrapper":"StartPage_wrapper__YO1c3","title":"StartPage_title__BHXM5","users":"StartPage_users__fmF5b","user":"StartPage_user__BrB4a","name":"StartPage_name__6aCbg"};